import { render, staticRenderFns } from "./UserFormFills.vue?vue&type=template&id=6df460ae&scoped=true"
import script from "./UserFormFills.vue?vue&type=script&lang=js"
export * from "./UserFormFills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df460ae",
  null
  
)

export default component.exports